module.exports = __webpack_public_path__ + "static/assets/ed523e83c862293741568a89219e5dcf.svg";